<template>
  <div class="text-sm text-right my-1">
    <span class="mr-4 text-gray-600">Visar {{ start }} till {{ stop }} av {{ total }}</span>
    <div class="inline-block border rounded border-gray-200 text-base">
      <span v-if="page > 1" class="border-r px-4 text-blue-600 font-bold"><a href="#" @click="$emit('prev')">&lt;</a></span>
      <span v-if="total > perPage" class="px-4">{{ page }}</span>
      <span v-if="total > perPage*page" class="border-l px-4 text-blue-600 font-bold"><a href="#" @click="$emit('next')">&gt;</a></span>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
      }
    },
    computed: {
      start() {
        return 1 + (this.page - 1) * this.perPage
      },
      stop() {
        return Math.min(this.perPage + (this.page - 1) * this.perPage, this.total)
      },
    },
    methods: {
    },
    props: {
      url: String,
      total: Number,
      perPage: Number,
      page: Number,
    }
  }
</script>
